/* eslint-disable react-hooks/exhaustive-deps */
import "react-calendar/dist/Calendar.css";
import "./Attendance.css";
import { useEffect, useState } from "react";
import { hitApi } from "../utils/apiCall";
import { Card } from "react-bootstrap";
import sections2 from "./assets/sections2.png";
import { getTrueKeys } from "../utils/ObjKeyInArray";

const SelectSection = ({ setSectionfromComp }) => {
  const [selectedSection, setSelectedSection] = useState({});
  const [fetchedSectionList, setFetchedSectionList] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [theme] = useState(localStorage.getItem("theme"));

  // Handle changes when a checkbox is clicked
  const handleChange = (value) => {
    setSelectedSection((prev) => {
      const newState = { ...prev, [value]: !prev[value] };
      return newState;
    });
  };

  // Load the selected branches from localStorage and set them in state
  useEffect(() => {
    const storedSections = JSON.parse(localStorage.getItem("section"));
    if (storedSections) {
      setSelectedSection(storedSections);
    }
  }, []);

  // Save selected branches to localStorage whenever selectedSection changes
  useEffect(() => {
    if (Object.keys(selectedSection).length > 0) {
      localStorage.setItem("section", JSON.stringify(selectedSection));
    }
    setSectionfromComp(selectedSection);
  }, [selectedSection]);

  // Fetch the branch list from API
  useEffect(() => {
    async function getSectionList() {
      const fd = new FormData();
      setIsLoading(true);
      getTrueKeys(JSON.parse(localStorage.getItem("branch"))).forEach((ele) =>
        fd.append("branch[]", ele)
      );
      getTrueKeys(JSON.parse(localStorage.getItem("class"))).forEach((ele) =>
        fd.append("class[]", ele)
      );
      // const res = await hitApi('teacher/teacherCurl', 'getSectionDetails', fd);
      const res = await hitApi(
        "multiple/getMultipleDetails",
        "getMultipleSectionDetailsOnChangeOfBranch",
        fd
      );
      console.log(res);

      if (res.success) {
        setFetchedSectionList(res.data);
        setIsLoading(false);
      } else {
        setFetchedSectionList(res.data);
        setIsLoading(false);
      }
    }
    getSectionList();
  }, []);

  return (
    <div
      style={{ maxHeight: "73vh", overflow: "hidden", overflowY: "auto" }}
      className="p-1 pb-5"
    >
      {isLoading ? (
        <div className="row ">
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
          <div className="p-2 col-6 m-0">
            <div className="card" aria-hidden="true">
              <div className="card-body">
                <h5 className="card-title d-flex justify-content-between placeholder-glow m-0">
                  <span className="placeholder col-2 rounded-2"></span>
                  <span className="placeholder col-8 rounded-2"></span>
                </h5>
              </div>
            </div>
          </div>
        </div>
      ) : (
        fetchedSectionList?.map((ele) => (
          <label
            key={ele.value}
            className="cursor-pointer position-relative col-6 p-1"
          >
            <input
              type="checkbox"
              id={ele.label}
              value={ele.key}
              checked={selectedSection[ele.key] || false}
              onChange={() => {
                handleChange(ele.key);
              }}
              className="opacity-0 position-absolute"
            />
            <Card
              className={`p-1 flex flex-col absolute border rounded-4 transition-all duration-300 ${
                selectedSection[ele.key]
                  ? "bg-primary-subtle shadow-sm"
                  : "border-gray-300"
              }`}
            >
              <Card.Body
                style={{ height: "4rem" }}
                className="d-flex justify-content-center align-items-center"
                px-1
              >
                <img src={sections2} alt="" width={30} />
                <p
                  className={`fw-bold d-block text-left m-0 ms-3 fz-12 text-gray-500 ${
                    theme === "dark"
                      ? selectedSection[ele.key]
                        ? "text-black"
                        : "text-white"
                      : ""
                  }`}
                >
                  {ele.label}
                </p>
              </Card.Body>
            </Card>
          </label>
        ))
      )}
    </div>
  );
};

export default SelectSection;
